/*@flow*/
/** @jsx jsx */
import { jsx, css } from '@emotion/core';
import { forwardRef } from 'react';

const Component = (
  props: {
    preface?: React$Node,
    styles?: string,
    innerStyles?: string,
    children: React$Node,
  },
  ref
) => {
  return (
    <div
      ref={ref}
      css={css(`
            display: grid;
            grid-template-rows: auto 1fr;
            grid-template-columns: 100%;
            padding: 8px 1rem 0;
            ${props.styles || ''}
      `)}
    >
      <div>{props.preface || null}</div>
      <div
        css={css(`
              display: grid;
              width: 100%;

              padding: 1rem 0;
              ${props.innerStyles || ''}
        `)}
      >
        {props.children || null}
      </div>
    </div>
  );
};

export default forwardRef<*, *>(Component);
